export class CreateImageProfile {
    constructor(ImageProfileRepository) {
      this.ImageProfileRepository = ImageProfileRepository;
    }
  
    async execute(ImageProfile) {
      return await this.ImageProfileRepository.CreateImageProfile(ImageProfile);
    }
  }